
<div class="flow-checkbox-wrapper" :disabled="disabled">
	<div>
		<div
			class="flow-checkbox"
			:tabindex="tabindex"
			:checked="innerChecked"
			:indeterminate="indeterminate"
			:disabled="disabled"
			:state="state"
			:size="size"
			@click="handleClick($event)"
		>
			<svg
				v-if="innerChecked && !indeterminate"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
			>
				<path d="M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828" />
			</svg>
			<svg
				v-if="indeterminate && !innerChecked"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
			>
				<path d="M4 12 L20 12 Z" />
			</svg>
		</div>
		<div class="flow-checkbox-label" @click="handleClick($event)">
			<!-- @slot Used to display checkbox label-->
			<slot />
		</div>
	</div>
	<div v-if="$slots['child-checkboxes']" class="flow-child-checkbox">
		<!-- @slot Used to display checkbox hierarchy-->
		<slot name="child-checkboxes" />
	</div>
</div>
